import { Component, OnInit } from '@angular/core';
import { LibraryService } from 'src/app/services/Library/library.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-library-configuation',
  templateUrl: './library-configuation.component.html',
  styleUrls: ['./library-configuation.component.css']
})
export class LibraryConfiguationComponent implements OnInit {

  PersonTypeList:any;
  Submitted:boolean=false;
  LibList:any;

  constructor(private  libraryservice: LibraryService,private lookupservice: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

LibraryConfiguationModel = {

    PersonTypeID: 0,
    LibConfigurationID: 0,
    FinePerDay: 0,
    IssuePeriod: 0,
    DueDateReminder: 0,
    ItemIssueLimit: 0
}

GetAllPersonType() {
    this.lookupservice.GetLookupsList('PersonType', '').subscribe((data: any) => {
        this.PersonTypeList = data.LookupItems;
    });
};


Validation() {

    return this.LibraryConfiguationModel.PersonTypeID == 0;
}


SaveLibraryConfiguation(valid) {

    this.Submitted = true;

    if (valid && !this.Validation()) {

      this.spinnerService.show();

        this.libraryservice.SaveLibraryConfiguation(JSON.stringify(this.LibraryConfiguationModel)).subscribe( (response:any) =>{
            
              this.spinnerService.hide();
            

            if (response.webResponse.Status) {
                this.globalHelper.CheckActionStatus(response);
                this.ClearLibraryConfiguation();
                this.GetLibraryConfiguation();
            }

        });
    }
};

ClearLibraryConfiguation = function () {

    this.LibraryConfiguationModel.PersonTypeID = 0,
   this.LibraryConfiguationModel.LibConfigurationID = 0,
   this.LibraryConfiguationModel.FinePerDay = 0,
   this.LibraryConfiguationModel.IssuePeriod = 0,
   this.LibraryConfiguationModel.ItemIssueLimit = 0,
   this.Submitted = false;
}

GetLibraryConfiguation () {
   this.spinnerService.show();
    this.libraryservice.GetLibraryConfiguation().subscribe( (response:any) => {
       this.LibList = response.LibList;
       this.spinnerService.hide();

    });

};

LibraryConfiguationEdit(obj) {
    
   this.LibraryConfiguationModel.PersonTypeID = parseInt(obj.PersonTypeID);
   this.LibraryConfiguationModel.LibConfigurationID = obj.LibConfigurationID;
   this.LibraryConfiguationModel.FinePerDay = obj.FinePerDay;
   this.LibraryConfiguationModel.IssuePeriod = obj.IssuePeriod;
   this.LibraryConfiguationModel.ItemIssueLimit = obj.ItemIssueLimit;
}

ngOnInit () {
   this.GetAllPersonType();
   this.GetLibraryConfiguation();
}

}
